<div class="wrapper">
    @if (isLoggedIn()) {
        <app-side-nav [currentUrl]="currentUrl()" />
    }
    <section class="content">
        @if (isLoggedIn()) {
            <app-header [currentUrl]="currentUrl()" [user]="user()" class="header"></app-header>
            <div25-chat-bubble [isVisible]="chatBubbleVisible()" [chatUrl]="caddieChatUrl"></div25-chat-bubble>
        }
        @if (isLoading()) {
            <app-loading-spinner
                [ngClass]="{ fadeIn: fade(), fadeOut: !fade() }"
                [placeholder]="loadingCaption()"
            ></app-loading-spinner>
        }
        <div class="componentContainer">
            <router-outlet></router-outlet>
        </div>
    </section>
    <lib-snackbar-notifications-container></lib-snackbar-notifications-container>
</div>
